// extracted by mini-css-extract-plugin
export default {"SetCommissionPop":"SetCommissionPop_SetCommissionPop__qHW9c","modalBody":"SetCommissionPop_modalBody__C-Cce"};